export default function StatsCounter() {
  return null;
}
